<template>
  <sChip
    :background="colorProps.background"
    class="status-chip"
    :color="colorProps.color"
    data-qa="status">
    <TooltipedText
      class="status-chip__text"
      :max-length="25"
      :value="statusText"/>
    <slot/>
  </sChip>
</template>
<script>
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import { datePickerMixin, modalMixin } from 'mixins'

export default {
  name: 'statusChip',
  mixins: [ datePickerMixin, modalMixin ],
  data() {
    return {
      isObject: false
    }
  },
  props: {
    status: [String, Object],
    keyName: { type: String, default: 'tenderStatusId' },
    valueName: { type: String, default: 'tenderStatusTitle' },
    name: { type: String },
    /**нужно только для файлов контрактов */
    color: String,
    textColor: {
      type: String,
    }
  },
  computed: {
    colorProps() {
      if (!this.status) {
        return {
          background: 'var(--grey-light-color)',
          color: 'var(--grey-color)'
        }
      }
      /**нужно только для файлов контрактов */
      if (this.color) {
        return {
          background: this.color,
          color: 'var(--white-color)'
        }
      }
      
      const defaultResult = this.getColor(this.status, this.object, this.keyName)
      return {
        background: this.color ?? defaultResult.background,
        color: this.textColor ?? defaultResult.color
      }
    },
    statusText() {
      if (!this.status) {
        return ''
      }
      if (!this.object && !this.name) {
        return this.$t(`Application.${this.bigFirstLetter(this.status)}`)
      }
      const key = this.name || this.valueName
      return this.status
        ? this.status[key] || key
        : this.name || '–'
    },
    object() {
      return this.status && typeof this.status == 'object'
    }
  },
  components: {
    TooltipedText
  }
}
</script>
<style lang="scss" scoped>
.status-chip {
  width: min-content;
  font-weight: 600;
  height: 24px;
  border-radius: 50px;
}
.status-chip__text {
  font-size: 11px;
  line-height: 12px;
}
</style>